import { api } from "@api/api";
import { AudioFile } from "@modules/audioFiles/types";
import { AudioFileFormValues } from "@modules/audioFiles/validations";

export async function editAudioFileService(id: string, data: Partial<AudioFileFormValues>): Promise<AudioFile> {
  const { file, ...body } = data;

  const payload = !file ? { ...body, file: null } : body;

  const { data: audioFile } = await api.patch<AudioFile>(`v1/audiobook_admin/${id}/`, payload);

  if (file && file instanceof File) {
    const formData = new FormData();
    formData.append("file", file);

    const { data: audioFile } = await api.patch<AudioFile>(`v1/audiobook_admin/${id}/`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return audioFile;
  }

  return audioFile;
}
